function safeJsonParse(key, defaultValue) {
    const value = localStorage.getItem(key)

    if (
        value === null ||
        value === undefined ||
        value === '' ||
        value === 'undefined' ||
        value === 'null'
    ) {
        return defaultValue
    }

    try {
        return JSON.parse(value)
    } catch (e) {
        console.warn(`[store/state] localStorage ${key} 解析失败，已使用默认值：`, value)
        localStorage.removeItem(key)
        return defaultValue
    }
}

export default {
    currenUser: null,
    isLogin: false,
    token: '',
    selectedcar: '',

    userInfo: safeJsonParse('userInfo', ''),

    swiperImg: safeJsonParse('homeBanner', []),

    onCollectListX: {}
}
